"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const office_ui_fabric_react_1 = require("office-ui-fabric-react");
const styles_1 = require("./shared/styles");
const LogoTitle_1 = __importDefault(require("./shared/LogoTitle"));
const MobileNav = () => react_1.default.createElement(office_ui_fabric_react_1.Stack, { horizontal: true, verticalAlign: "center", horizontalAlign: "space-between", styles: styles_1.navBarWrapperStyle },
    react_1.default.createElement(office_ui_fabric_react_1.Stack.Item, null,
        react_1.default.createElement(office_ui_fabric_react_1.Stack, { horizontal: true },
            react_1.default.createElement(LogoTitle_1.default, null))),
    react_1.default.createElement(office_ui_fabric_react_1.Stack.Item, null,
        react_1.default.createElement(office_ui_fabric_react_1.Stack, { horizontal: true },
            react_1.default.createElement(office_ui_fabric_react_1.IconButton, { iconProps: { iconName: 'GlobalNavButton' }, title: "Menu", ariaLabel: "Menu", styles: styles_1.iconButtonStyle }))));
exports.default = MobileNav;
